import PropTypes from 'prop-types';
import { NumericInput } from '@evertrue/et-components';

const CustomDoubleField = ({ value, customField = {}, handleChange = () => {}, handleTouched = () => {} }) => {
  return (
    <div className="interaction-custom-fields-form--small-input">
      <NumericInput
        allowDecimal={true}
        value={value}
        maskType="currency"
        showIcon={true}
        onChange={(value) => handleChange(customField.id, value)}
        onBlur={handleTouched}
      />
    </div>
  );
};

CustomDoubleField.propTypes = {
  value: PropTypes.any,
  customField: PropTypes.shape({
    id: PropTypes.number.isRequired,
    displayName: PropTypes.string.isRequired,
    dataType: PropTypes.string.isRequired,
    required: PropTypes.bool,
    uiControlType: PropTypes.string,
  }).isRequired,
  handleChange: PropTypes.func.isRequired,
  handleTouched: PropTypes.func,
};

export default CustomDoubleField;
